import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. Login with your new password.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="max-w-5xl w-full mx-auto px-6 pt-8">
        <Link to="/" className="flex items-center gap-3 w-fit">
          <span className="solera-symbol" />
          <span className="wordmark text-bone text-sm">Solera</span>
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rise" data-testid="reset-password-panel">
          <span className="t-label">Choose a new password</span>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input className="input-solera" type="password" placeholder="New password, 8 characters minimum"
              value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password-input" />
            <input className="input-solera" type="password" placeholder="Confirm new password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm-input" />
            {error && <p className="t-small status-blocked" data-testid="reset-error">{error}</p>}
            <button className="btn-primary w-full" disabled={busy || !token} data-testid="reset-submit-button">
              {busy ? "Saving" : "Reset password"}
            </button>
            {!token && <p className="t-small status-blocked">This reset link is missing its token.</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
